export const NOUN = 'DETAIL_PANEL'
export const TOGGLE = 'TOGGLE'
export const OPEN = 'OPEN'
export const CLOSE = 'CLOSE'
export const LOAD = 'LOAD'



// WEBPACK FOOTER //
// ./src/components/detail-panel/constants.ts